import { Article } from '../legacy';
import { IImage } from '..';

export enum PrivacyStatus {
  /** 未取值时 */
  Init = -2,
  /** 正常没有设置privacy的用户 */
  Normal = -1,
  UserPageNoPermission = 0,
  UserPageHasPermission = 1,
  PrivateUser = 2,
  UnderAge = 3,
}

export interface UserRelated {
  following_count: number;
  has_more: boolean;
  impr_id: string;
  offset: number;
  session_impr_id: string;
  users: RelatedUser[];
}

export interface RelatedUser {
  description: string;
  followers_count: number;
  following_count: number;
  avatar: IImage;
  id: string;
  name: string;
  unique_name: string;
  recommend_reason: string;
  user_auth_info: string;
  user_liked_count: number;
  post_count: number;

  article_metas: {
    article_class: string;
    cover_images: IImage[];
    group_id: string;
    img_url: IImage;
    item_id: string;
    short_content: string;
    title: string;
  }[];
}

export interface UserPosts {
  items: Article[];
  hasMore: boolean;
  maxBeHotTime?: number;
  offset: number;
}

export interface UserInfo {
  // 用户id
  user_id: string;
  user_id_str: string;
  media_id: string;
  media_id_str: string;
  // 用户名，用于展示
  name: string;
  // 用户描述
  description: string;
  // 认证信息
  user_auth_info: string;
  // 1:可展示，0:不可展示
  user_status: number;
  // 头像
  icon_url: string;
  // 1:已关注该用户，0:未关注
  is_following: number;
  // 1:已被该用户关注，0:未被关注
  is_followed: number;
  // 发文数
  posts_count: number;
  // 关注数
  following_count: number;
  // 粉丝数
  followers_count: number;
  // 背景图url
  background_url: string;
  // 分享数
  share_count: number;
  // 用户标签
  user_tags: {
    name: string;
    text: string;
  }[];
  // 拉黑主页用户或被主页用户拉黑，此时不能查看该主页
  is_blocked: boolean;
  // 被主页用户拉黑
  is_blocked_by_profile: boolean;
  // 拉黑主页用户
  is_blocking_profile: boolean;
  privacy_status: PrivacyStatus;
  // 个人网址
  personal_url: string;
  // 用户被点赞总数
  user_liked_count: number;
  // 草稿数量，N项目主态个人页展示
  draft_count: number;
  // 点赞总数
  digg_count: number;
  // 收藏总数
  favorite_count: number;
  tabs: UserTabType[];
  [key: string]: any;
}

export interface UserTabType {
  id: string;
  show_name: string;
  is_default: boolean;
  visibility: boolean;
}
